module.exports = __webpack_public_path__ + "static/media/twins_yellow.4bc7f928.jpg";